<template>
    <div class="common-header">
        <div class="height d-none d-lg-flex align-items-center">
            <slot name="breadcrumb">
                <b-breadcrumb class="mb-0 p-0">
                    <template v-if="firstBreadcrumbItem.text">
                        <b-breadcrumb-item
                                html="<i class='far fa-home-alt'></i>"
                                @click="handleBreadcrumbItemClick(firstBreadcrumbItem)"
                                class="d-flex align-items-center"
                                :disabled="breadcrumbsDisabled"
                        />
                    </template>

                    <slot name="breadcrumb-items">
                        <b-breadcrumb-item
                                v-for="(item,index) in breadcrumbs"
                                :key="index"
                                :text="item.text"
                                :active="item.active"
                                :disabled="breadcrumbsDisabled"
                                class="d-flex align-items-center"
                                @click="handleBreadcrumbItemClick(item)"
                        />
                    </slot>
                </b-breadcrumb>
            </slot>
            <div class="ml-auto">
                <template
                    v-if="dropdownVisible"
                >
                    <slot name="dropdown">
                        <b-dropdown
                            size="custom-size"
                            right
                            menu-class="nice-scrollbar"
                            :no-caret="!dropdownItems.length"
                        >
                            <template v-slot:button-content>
                                <i class="far fa-university text-gray-700" />
                                <span
                                    class="h3 mb-0 font-weight-bold ml-1"
                                    :class="{'mr-3': Boolean(dropdownItems.length)}"
                                >
                                    {{ selectedDropdownItem.name }}
                                </span>
                            </template>
                            <template v-if="dropdownItems.length">
                                <b-dropdown-item
                                    v-for="(item, index) in dropdownItems"
                                    :key="index"
                                    @click="handleDropdownItemClick(item)"
                                >
                                    {{ item.name }}
                                    <i
                                        v-if="selectedDropdownItem[dropdownItemUniqueIdentifier] ===
                                        item[dropdownItemUniqueIdentifier]"
                                        class="far fa-check text-success"
                                    />
                                </b-dropdown-item>
                            </template>
                        </b-dropdown>
                    </slot>
                </template>

                <slot name="bell" />
            </div>
        </div>
        <div class="height d-flex d-lg-none  align-items-center">
            <b-button
                    class="btn-back pl-0"
                    variant="link"
                    @click="handleBackClick"
                    v-if="!hideMobileBackButton"
            >
                <i class="far fa-long-arrow-left text-gray-700" />
            </b-button>
            <h3
                    class="mb-0 font-weight-bold"
                    v-if="mobileTitle"
            >
                {{ mobileTitle.name }}
            </h3>
            <h3
                    class="mb-0 font-weight-bold"
                    v-else-if="!selectedDropdownItem.editable"
            >
                {{ selectedDropdownItem.name }}
            </h3>
            <page-header-title
                    v-else
                    v-model="selectedDropdownItem.name"
                    editable
                    @input="handleTitleEditInput"
            />
            <div class="ml-auto">
                <template v-if="mobileDropdownVisible || tabletDropdownVisible">
                    <slot name="dropdown">
                        <b-dropdown
                                size="custom-size"
                                right
                                menu-class="nice-scrollbar"
                                class="mobile-dropdown"
                                :class="{ 'picker-border': displayHamburgerMenu }"
                                :no-caret="!dropdownItems.length"
                        >
                            <template v-slot:button-content>
                                <span
                                        class="h3 mb-0 font-weight-bold ml-1"
                                        :class="{'mr-3': Boolean(dropdownItems.length)}"
                                >
                                    {{ selectedDropdownItem.name }}
                                </span>
                            </template>
                            <template v-if="dropdownItems.length">
                                <b-dropdown-item
                                        v-for="(item, index) in dropdownItems"
                                        :key="index"
                                        @click="handleDropdownItemClick(item)"
                                >
                                    {{ item.name }}
                                    <i
                                            v-if="selectedDropdownItem[dropdownItemUniqueIdentifier] === item[dropdownItemUniqueIdentifier]"
                                            class="far fa-check text-success"
                                    />
                                </b-dropdown-item>
                            </template>
                        </b-dropdown>
                    </slot>
                </template>
            </div>
            <div class="ml-2 d-flex">
                <slot name="recommended"/>
                <slot
                        name="hamburger"
                        v-if="displayHamburgerMenu"
                >
                    <animate-hamburger
                            animate
                            class="mt-2"
                    />
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
import './CommonHeader.scss';
import './CommonHeader.mobile.scss';
import AnimateHamburger from "../../../components/AnimateHamburger/AnimateHamburger";
import PageHeaderTitle from '../../PageHeaderTitle/PageHeaderTitle';

export default {
    name: "CommonHeader",
    components: {AnimateHamburger, PageHeaderTitle},
    props: {
        breadcrumbs: {
            type: Array,
            default: () => {
                return [];
            }
        },
        selectedDropdownItem: {
            type: Object,
            default: () => {
                return {
                    name: '',
                    uuid: ''
                };
            }
        },
        mobileTitle: {
            type: Object,
            default: () => {
                return {
                    name: ''
                };
            }
        },
        dropdownItems: {
            type: Array,
            default: () => {
                return [];
            }
        },
        dropdownItemUniqueIdentifier: {
            type: [String, Number],
            default: 'uuid'
        },
        firstBreadcrumbItem: {
            type: Object,
            default: () => {
                return {
                    text: '',
                    to: '',
                };
            }
        },
        breadcrumbsDisabled: {
            type: Boolean,
            default: false
        },
        dropdownVisible: {
            type: Boolean,
            default: true
        },
        mobileDropdownVisible: {
            type: Boolean,
            default: false
        },
        tabletDropdownVisible: {
            type: Boolean,
            default: false
        },
        hideMobileBackButton: {
            type: Boolean,
            default: false
        },
        displayHamburgerMenu: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {};
    },
    methods: {
        handleDropdownItemClick(item) {
            this.$emit('dropdown-item-click', item);
        },

        handleBackClick() {
            this.$emit('back-click', true);
        },

        handleBreadcrumbItemClick(item) {
            this.$emit('breadcrumb-item-click', item);
        },

        handleTitleEditInput(value) {
            if (!value) {
                return;
            }

            this.$emit('title-edit', value);
        }
    }
};
</script>
